module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar-contact-form"
  }, [_c('div', {
    staticClass: "contact-heading block-heading-font-style"
  }, [_vm._v(_vm._s(_vm.contactContent.heading))]), _vm._v(" "), _c('div', {
    staticClass: "contact-subheading block-subheading-font-style"
  }, [_vm._v(_vm._s(_vm.contactContent.subheading))]), _vm._v(" "), _c('form', {
    staticClass: "mm-contact-form",
    attrs: {
      "id": "mm-contact-form",
      "method": "post"
    }
  }, [_vm._l((_vm.contactContent.formFields), function(input) {
    return (input.required) ? _c('input', {
      class: input.className,
      attrs: {
        "type": input.type,
        "name": input.name,
        "placeholder": ((input.placeholder) + " (required)"),
        "required": ""
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.contactContent.formFields), function(input) {
    return (!input.required) ? _c('input', {
      class: input.className,
      attrs: {
        "type": input.type,
        "name": input.name,
        "placeholder": input.placeholder
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('input', {
    staticClass: "footer-bar-contact-form-submit",
    attrs: {
      "type": "submit",
      "name": "",
      "value": "Submit"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "mm-contact-form-success",
    attrs: {
      "id": "mm-contact-form-success"
    }
  }, [_vm._v(_vm._s(_vm.contactContent.successMessage))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5353a330"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/ContactUs.vue
// module id = 478
// module chunks = 0